module.exports = __webpack_public_path__ + "static/media/provider-pg.71378841.png";